import {
  faArrowLeft,
  faXmark,
  faArrowRight,
  faPlus,
  faTriangleExclamation,
  faRightToBracket,
  faFileImport,
  faFileExport,
  faCloudArrowDown,
  faMinus,
  faPrint,
  faFileCirclePlus,
  faCheckSquare,
  faSquare,
  faWrench,
  faReceipt,
  faFileCircleXmark,
  faList,
  faEraser,
  faCheck,
  faRefresh,
  faEye,
  faCheckCircle,
  faCheckToSlot,
  faCheckDouble,
  faPencil,
  faCalendarCheck,
  faExternalLink,
  faLocationDot,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCircleQuestion,
  faSave,
  faTrashCan as faTrash,
} from '@fortawesome/free-regular-svg-icons';
import { faSquare as faSquareRegular } from '@fortawesome/free-regular-svg-icons';
import { ButtonsType } from '@/core/enums/buttons.enums';

/**
 * Configuration mapping button types to FontAwesome icons
 * This centralizes icon mapping and makes it easier to maintain and extend
 */
export const BUTTON_ICON_MAP = {
  [ButtonsType.SAVE]: faSave,
  [ButtonsType.BACK]: faArrowLeft,
  [ButtonsType.FORWARD]: faArrowRight,
  [ButtonsType.TRASH]: faTrash,
  [ButtonsType.ADD]: faPlus,
  [ButtonsType.LIST]: faList,
  [ButtonsType.INFO]: faEye,
  [ButtonsType.EDIT]: faPencil,
  [ButtonsType.REGULAR_QUESTION]: faCircleQuestion,
  [ButtonsType.SOLID_TRIANGLE_EXCLAMATION]: faTriangleExclamation,
  [ButtonsType.SOLID_RIGHT_TO_BRACKET]: faRightToBracket,
  [ButtonsType.SOLID_FILE_EXPORT]: faFileExport,
  [ButtonsType.SOLID_FILE_IMPORT]: faFileImport,
  [ButtonsType.CLOUD_DOWNLOAD]: faCloudArrowDown,
  [ButtonsType.MINUS]: faMinus,
  [ButtonsType.PRINT]: faPrint,
  [ButtonsType.FA_FILE_CIRCLE_PLUS]: faFileCirclePlus,
  [ButtonsType.FA_CHECK_SQUARE]: faCheckSquare,
  [ButtonsType.FA_SQUARE]: faSquare,
  [ButtonsType.FA_WRENCH]: faWrench,
  [ButtonsType.FA_FILE_CIRCLE_XMARK]: faFileCircleXmark,
  [ButtonsType.FA_XMARK]: faXmark,
  [ButtonsType.REFRESH]: faRefresh,
  [ButtonsType.APPROVE]: faCheckToSlot,
  [ButtonsType.FA_ERASER]: faEraser,
  [ButtonsType.CANCEL]: faXmark,
  [ButtonsType.RECEIPT]: faReceipt,
  [ButtonsType.EYE]: faEye,
  [ButtonsType.FA_CHECK_CIRCLE]: faCheckCircle,
  [ButtonsType.CONFIRM]: faCheckDouble,
  [ButtonsType.DETAIL]: faExternalLink,
  // Legacy icon types that map to standard FontAwesome icons
  [ButtonsType.FA_FILE_EXPORT_THIN]: faFileExport,
  [ButtonsType.FA_SQUARE_DOUTONE]: faSquare,
  [ButtonsType.FA_SQUARE_LIGHT]: faSquare,
  [ButtonsType.FA_SQUARE_REGULAR]: faSquareRegular,
  [ButtonsType.CIRCLE_CHECK_CLASSIC_REGULAR]: faCheck,
  [ButtonsType.MEMO_CIRCLE_CHECK_CLASSIC_LIGHT]: faCheck,
  [ButtonsType.MEMO_CIRCLE_CHECK_CLASSIC_SOLID]: faCheck,
  [ButtonsType.DONE]: faCalendarCheck,
  [ButtonsType.LOCATION_DOT]: faLocationDot,
} as const;

/**
 * Default icon for buttons that don't have a specific icon defined
 */
export const DEFAULT_BUTTON_ICON = faXmark;

/**
 * Get icon for a specific button type
 * @param buttonType - The button type from ButtonsType enum
 * @returns FontAwesome icon or default icon
 */
export const getButtonIcon = (buttonType: ButtonsType) => {
  return BUTTON_ICON_MAP[buttonType] || DEFAULT_BUTTON_ICON;
};
